import { HttpHeaders } from "@angular/common/http";

export const getHeadersWithToken = () => {
  const token = localStorage.getItem("token") || false;
  const headers = new HttpHeaders().append("authorization", `Bearer ${token}`);

  return headers;
};
